import request from '@/utils/request'

export function getsms (data) {
  return request({
    url: '/index/registration/login/getsms',
    method: 'post',
    data
  })
}

export function login (data) {
  return request({
    url: '/index/registration/login/final_login',
    method: 'post',
    data
  })
}

export function resetpwd (data) {
  return request({
    url: '/index/registration/login/final_resetpwd',
    method: 'post',
    data
  })
}

export function fetchBasic (params) {
  return request({
    url: '/index/registration/finals/getBasic',
    method: 'get',
    params
  })
}

export function fetchStudentList (params) {
  return request({
    url: '/index/registration/finals/getStudentList',
    method: 'get',
    params
  })
}

export function fetchInstructorList (params) {
  return request({
    url: '/index/registration/finals/getInstructorList',
    method: 'get',
    params
  })
}

export function fetchFileConfig (params) {
  return request({
    url: '/index/registration/finals/getFileConfig',
    method: 'get',
    params
  })
}

export function setWorksCnts (data) {
  return request({
    url: '/index/registration/finals/setWorksCnts',
    method: 'post',
    data
  })
}

export function submit (data) {
  return request({
    url: '/index/registration/finals/submit',
    method: 'post',
    data
  })
}

export function fetchQnUptoken (params) {
  return request({
    url: '/index/registration/finals/qn_uptoken',
    method: 'get',
    params
  })
}

export function delQnFile (data) {
  return request({
    url: '/index/registration/finals/del_qn_file',
    method: 'post',
    data
  })
}

export function fetchTrainingList (params) {
  return request({
    url: '/index/registration/finals/trainingList',
    method: 'get',
    params
  })
}

export function submitTraining (data) {
  return request({
    url: '/index/registration/finals/setTraining',
    method: 'post',
    data
  })
}
